import React from 'react'
import { useCurrentTab } from '../../../organisms/AdvisorView/components/AdvisorViewTabs'
import { ADMIN_ROUTES } from '../../../../constants'
import { useCheckPolicy } from '../../../../hooks'
import SydLinkButton from '../../../commonDesign/LinkButton'
import FadeIn from '../../../molecules/Transitions/FadeIn'

function HeaderActions () {
  const tabValue = useCurrentTab()
  const canEditBulkManual = useCheckPolicy('admin_manual_accounts')
  const canEditAltInvestments = useCheckPolicy('admin_alt_investments')
  const canEditManagers = useCheckPolicy('admin_edit_managers')

  if (tabValue === 'accounts') {
    if (!canEditBulkManual && !canEditAltInvestments) return null
    return (
      <FadeIn>
        <div style={{ display: 'flex', gap: '8px' }}>
          {canEditBulkManual ? (
            <SydLinkButton
              size='md'
              variant='outline'
              to='/admin/manual-accounts'
              icon='link'
            >
              Manual Accounts
            </SydLinkButton>
          ) : null}
          {canEditAltInvestments ? (
            <SydLinkButton
              size='md'
              variant='outline'
              to={ADMIN_ROUTES.ALTERNATIVE_INVESTMENTS_BATCH_NEW}
              icon='link'
            >
              Alternative Investments
            </SydLinkButton>
          ) : null}
        </div>
      </FadeIn>
    )
  }
  if (tabValue === 'managers' && canEditManagers) {
    return (
      <FadeIn>
        <SydLinkButton
          size='md'
          variant='primary'
          to={ADMIN_ROUTES.NEW_MANAGER}
          icon='add'
        >
          Add Manager
        </SydLinkButton>
      </FadeIn>
    )
  }

  return null
}

export default HeaderActions
